"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ApplicationLayout = exports.InternalApplicationLayout = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var ApplicationLayout_1 = __importDefault(require("@cjdev-internal/visual-stack/lib/layouts/ApplicationLayout"));
var InternalApplicationLayout = /** @class */ (function (_super) {
    __extends(InternalApplicationLayout, _super);
    function InternalApplicationLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InternalApplicationLayout.prototype.render = function () {
        return (react_1["default"].createElement(ApplicationLayout_1["default"], { sideNav: this.props.sideNav, sideNavState: !this.props.collapsed }, this.props.children));
    };
    return InternalApplicationLayout;
}(react_1["default"].Component));
exports.InternalApplicationLayout = InternalApplicationLayout;
var mapStateToProps = function (state) { return ({
    collapsed: state.visualStack.sideNav.collapsed,
    slidingPanelState: state.visualStack.slidingPanel.active
}); };
exports.ApplicationLayout = (0, react_redux_1.connect)(mapStateToProps, function () { return ({}); })(InternalApplicationLayout);
exports["default"] = exports.ApplicationLayout;
